import productImageNotAvailable from 'img/productImageNotAvailable.png'

export const IMAGE_BASE_URL = 'https://tcgpowertools.b-cdn.net/images/mtg'

export function getProductImageUrl(
  id?: number | string | null,
  pictureFilePath?: string | null
): string {
  if (pictureFilePath) return `${IMAGE_BASE_URL}/${pictureFilePath}`
  if (id) return `${IMAGE_BASE_URL}/${id}.jpg`
  return productImageNotAvailable
}
